export default __webpack_public_path__ + "static/media/businessdev.a65e8ae9.jpg";